import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import {
  ApolloClient,
  ApolloProvider,
  ApolloLink,
  InMemoryCache,
  HttpLink,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import fetchIntercept from "fetch-intercept";
import { store } from "./global/app/store";
import * as serviceWorker from "./global/app/serviceWorker";
import "./global/utils/extend_proto";
import App from "./global/app/App";
import Head from "./global/app/Head";
import CSRF from "./global/app/csrf";
import util from "./global/utils/Helpers";
// polyfill for IE
import "react-app-polyfill/ie11";
import "core-js/stable";
import "regenerator-runtime/runtime";

fetchIntercept.register({
  request: function (url, config) {
    if (window["CSRF-Token"]) {
      let headers =
        config && config.headers
          ? { ...config.headers, "CSRF-Token": window["CSRF-Token"] }
          : { "CSRF-Token": window["CSRF-Token"] };
      config = {
        ...config,
        headers,
      };
    }
    return [url, config];
  },
  requestError: function (error) {
    return Promise.reject(error);
  },
  response: function (res) {
    return res;
  },
  responseError: function (error) {
    return Promise.reject(error);
  },
});

let apiIndex = util.isLocalhost()
  ? "http://localhost:9393/auth/graphql"
  : `${util.getCurrentHost()}/auth/auth/graphql`;

const client = new ApolloClient({
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        graphQLErrors.forEach(({ message, locations, path }) => {
          if (message === "Unusual activity detected") {
            window.location.replace(
              `${util.getCurrentHost()}/auth/auth/logout`
            );
          }
        });
      }
      if (networkError) {
        if (
          networkError.message ===
          "Response not successful: Received status code 429"
        ) {
          window.location.replace(`${util.getCurrentHost()}`);
        }
      }
    }),
    new HttpLink({
      uri: apiIndex,
      credentials: "same-origin",
    }),
  ]),
  cache: new InMemoryCache(),
});

let gtagId = util.getGtagId();

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <CSRF>
    <Provider store={store}>
      <Head>
        <script
          async
          src={`https://www.googletagmanager.com/gtag/js?id=${gtagId}`}
        ></script>
      </Head>
      <ApolloProvider client={client}>
        <App />
      </ApolloProvider>
    </Provider>
  </CSRF>
);

window.dataLayer = window.dataLayer || [];
function gtag() {
  window.dataLayer.push(arguments);
}
gtag("js", new Date());
gtag("config", "UA-141695557-2");
gtag("config", gtagId);

serviceWorker.unregister();

export { client };
